function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  width: 60,
  height: 60,
  fill: "#fff"
}), React.createElement("rect", {
  x: 23,
  y: 23,
  width: 28,
  height: 14,
  rx: 7,
  fill: "#adafb5"
}), React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 5,
  fill: "#adafb5"
}), React.createElement("circle", {
  cx: 30.5,
  cy: 29.5,
  r: 7,
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10
}), React.createElement("rect", {
  x: 14,
  y: 25,
  width: 22,
  height: 10,
  rx: 5,
  fill: "#adafb5"
}), React.createElement("circle", {
  cx: 19,
  cy: 30,
  r: 3,
  fill: "#fff"
}), React.createElement("circle", {
  cx: 18.5,
  cy: 29.5,
  r: 5,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10
}), React.createElement("line", {
  x1: 19.5,
  y1: 27.5,
  x2: 12.5,
  y2: 27.5,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("line", {
  x1: 19.5,
  y1: 27.5,
  x2: 12.5,
  y2: 27.5,
  fill: "none",
  stroke: "#adafb5",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), React.createElement("line", {
  x1: 20.5,
  y1: 29.5,
  x2: 13.5,
  y2: 29.5,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), React.createElement("line", {
  x1: 20.5,
  y1: 29.5,
  x2: 13.5,
  y2: 29.5,
  fill: "none",
  stroke: "#adafb5",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), React.createElement("line", {
  x1: 20.5,
  y1: 31.5,
  x2: 13.5,
  y2: 31.5,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), React.createElement("line", {
  x1: 20.5,
  y1: 31.5,
  x2: 13.5,
  y2: 31.5,
  fill: "none",
  stroke: "#adafb5",
  strokeLinecap: "round",
  strokeMiterlimit: 10
}), React.createElement("line", {
  x1: 17.5,
  y1: 31.5,
  x2: 11.5,
  y2: 31.5,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), React.createElement("line", {
  x1: 17.5,
  y1: 31.5,
  x2: 11.5,
  y2: 31.5,
  fill: "none",
  stroke: "#adafb5",
  strokeLinecap: "round",
  strokeMiterlimit: 10
})));

function SvgCable(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/cable.379e0882.svg";
export { SvgCable as ReactComponent };